import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, debounceTime, map } from 'rxjs/operators'; 
import { environment as env } from 'src/environments/environment';
import { Movimentacao } from '../models/movimentacao';

@Injectable({
  providedIn: 'root'
})
export class GrupoService {
  private readonly PATH_BENS_GET_ALL = '/Bens/Grupos/GetAll';
  private readonly PATH_MOV_GET_ALL = '/Movimentacao/Grupos/GetAll';
  private readonly PATH_MOV_ALTERA_CAUTELA = '/Movimentacao/Grupos/AlteraCautela';
  constructor(private http:HttpClient) { }
  public errorHandl(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }
  listarBensPage(page:any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_BENS_GET_ALL,page) 
    .pipe(catchError(this.errorHandl));
  }
  listarMovPage(page:any): Observable<any> {
    return this.http.post(env.baseurl + this.PATH_MOV_GET_ALL,page) 
    .pipe(catchError(this.errorHandl));
  }
  insertAlterarCautelaGrupo(movimentacao:Movimentacao):Observable<any>{
    return this.http.post(
      env.baseurl + this.PATH_MOV_ALTERA_CAUTELA,movimentacao,
      { responseType: 'text' }
      );
  }
}
